import { render } from "./AdminEditProperty.vue?vue&type=template&id=194df1b4"
import script from "./AdminEditProperty.vue?vue&type=script&lang=js"
export * from "./AdminEditProperty.vue?vue&type=script&lang=js"

import "./AdminEditProperty.vue?vue&type=style&index=0&id=194df1b4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__